<template>
  <div>
    <div v-if="cart.length > 0 && !scan" class="bg-white w-8/12 mx-auto">
      <div class="flow-root bg-white w-10/12 mx-auto p-3">
        <ul role="list" class="-my-6 divide-y divide-gray-200">
          <li v-for="(item, idx) in cart" :key="idx" class="flex py-6">
            <div class="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
              <img :src="item.uri" :alt="item.product" class="h-full w-full object-cover object-center" />
            </div>

            <div class="ml-4 flex flex-1 flex-col">
              <div>
                <div class="flex justify-between text-base font-medium text-gray-900">
                  <div>
                    <h3 class="font-bold">
                    {{ item.product }}
                    </h3>
                    <p class="text-purple-500">{{item.id}}</p>
                  </div>
                  <p class="ml-4">${{ (item.price/100) }}</p>
                </div>
                <p class="mt-1 text-sm text-gray-500">{{ item.color }}</p>
              </div>
              <div class="flex flex-1 items-end justify-between text-sm">
                <p class="text-gray-500"></p>

                <div class="flex">
                  <button @click="removeItem(item.id)" type="button" class="font-medium text-indigo-600 hover:text-indigo-500">Remove</button>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

          <div class="border-t border-gray-200 py-6 px-4 sm:px-6">
            <div class="flex justify-between text-base font-medium text-gray-900">
              <p>Subtotal</p>
              <p>${{(total/100)}}</p>
            </div>
            <p class="mt-0.5 text-sm text-gray-500">Shipping and taxes calculated at checkout.</p>
            <div class="mt-6">
              <button @click="changeTab()" class="flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-700">Checkout</button>
            </div>
            <div class="mt-6 flex justify-center text-center text-sm text-gray-500">
              <p>
                or <a href="https://barkbadge.com" target="_blank" class="font-medium text-indigo-600 hover:text-indigo-500" >Check out our full store<span aria-hidden="true"> &rarr;</span></a>
              </p>
            </div>
          </div>
    </div>
    <div v-if="!loading">
      <div class="bg-red-100 flex items-center justify-center py-5 px-4 rounded w-8/12 mx-auto cursor-pointer relative" v-if="error">
        <h2 class="font-bold text-red-500 text-2xl">
          {{error}}
        </h2>
      </div>
      <qrcode-stream v-if="scan" @decode="onDecode" :track="outline"  :@init="logErrors" />

      <div  class="bg-yellow-100 flex items-center justify-center py-5 px-4 rounded w-8/12 mx-auto cursor-pointer relative" @click="openScan(true)">
         <div id="reader"></div>
        <img src="@/assets/icons/barcode-scanner.svg" class="w-10 m-4"/>
        <h2 class="font-bold text-yellow-500 text-2xl" v-if="cart.length == 0">
          Press to Scan a Bark Badge to Continue
        </h2>
        <h2 class="font-bold text-yellow-500 text-2xl" v-else>
          Press to Scan another Bark Badge
        </h2>
      </div>
    </div>
    <div v-else>
      <p>Please wait...</p>
    </div>

</div>
</template>

<script>
import axios from 'axios'
import { QrcodeStream} from 'vue-qrcode-reader'
import {mapState, mapMutations} from 'vuex'

export default{
  components: {
    QrcodeStream,
    // QrcodeDropZone,
    // QrcodeCapture
    },
  data(){
    return{
      error: '',
      scan: false,
      loading: false,
      outline: { text: "bounding box", value: this.paintBoundingBox },
    }
  },
  methods:{
    ...mapMutations(['SET_CART', 'SET_PARTNER']),
    paintBoundingBox (detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const { boundingBox: { x, y, width, height } } = detectedCode

        ctx.lineWidth = 2
        ctx.strokeStyle = '#007bff'
        ctx.strokeRect(x, y, width, height)
      }
    },
    openScan(bool){
      this.scan = bool
    },
    getSecondPart(url) {
      let val = url.split('?sc=')[1];
      if(!val){
        val = url.split('/tag/')[1];
      }
      console.log('value extracted', val)
      return val
    },
    onDecode(url){
      let val = this.getSecondPart(url)
      this.checkTag(val)
      this.openScan(false)
    },
    async onInit (promise) {
       try {
         await promise
       } catch (error) {
         if (error.name === 'NotAllowedError') {
           this.error = "ERROR: you need to grant camera access permission"
         } else if (error.name === 'NotFoundError') {
           this.error = "ERROR: no camera on this device"
         } else if (error.name === 'NotSupportedError') {
           this.error = "ERROR: secure context required (HTTPS, localhost)"
         } else if (error.name === 'NotReadableError') {
           this.error = "ERROR: is the camera already in use?"
         } else if (error.name === 'OverconstrainedError') {
           this.error = "ERROR: installed cameras are not suitable"
         } else if (error.name === 'StreamApiNotSupportedError') {
           this.error = "ERROR: Stream API is not supported in this browser"
         } else if (error.name === 'InsecureContextError') {
           this.error = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
         } else {
           this.error = `ERROR: Camera error (${error.name})`;
         }
       }
     },
    changeTab(){
      this.$emit('changeTab', 1)
    },
    removeItem(sn){
      let temp_cart = this.cart
      const result = temp_cart.filter((x)=> x.id != sn);
      this.SET_CART(result)
    },
    checkTag(serial_number){
      let payload = {
        serial_number: serial_number,
        userID: '',
        userDevice: navigator.platform
      }
      if (this.location != null){
        payload['coodinates'] = this.location
      }else{
          payload['coodinates'] = {latitude: null, longitude: null}
      }
      this.loading = true
      axios.post('https://barkbadge.pythonanywhere.com/device/scan', payload
      ).then((res)=>{
        let scan = res.data
        const tag_data = scan.tag_data
        if(scan.action == 'error_404'){
          alert('This is not a valid Bark Badge device')
        }
        else if(scan.action == 'not_activated'){
          this.loading = false
          if(tag_data.isLocked){

          let partnerID = ''
          if(tag_data.metadata != undefined || tag_data.metadata != null){
            partnerID = tag_data.metadata.partnerID
            if(partnerID != this.partner_id){
              // alert('This tag is assigned to another shelter. Are you sure you want to exit this shelter\'s shop?')
              alert('This tag is assigned to another shelter. Are you sure you want to exit this shelter\'s shop?')
            }
            this.SET_PARTNER(partnerID)
          }

            const new_badge  = {product: 'Bark Badge', price: 2795, secured_code: tag_data.secure_code, id: tag_data.id, uri: 'https://firebasestorage.googleapis.com/v0/b/petproject-qbelnc.appspot.com/o/site_assets%2F2022-logo.png?alt=media&token=5fd23703-de91-4220-a819-62d65529dab7'}
            let temp_cart = this.cart
            if(temp_cart.length > 0 ){
              if(temp_cart.find(c => c.id == tag_data.id)){
                alert('This device has already been added to your cart.')
              }else{
                temp_cart.push(new_badge)
              }
            }else{
              temp_cart.push(new_badge)
            }
            this.SET_CART(temp_cart)

            this.$router.push({name: 'OnTheGoCheckout'})
          }else{
            this.$router.push({name: 'OnboardingMain'})
          }
        }else{ //Check if scan is activated
          this.loading = false
          alert('This device is not for sale')
        }
        this.loading= false
      }).catch((err)=>{
        console.log(err)
      })
    },
  },
  computed:{
    total(){
      let amount = 0
      const cart = this.cart
      for(let ct in cart){
        amount = cart[ct].price + amount
      }
      return amount
    },
    ...mapState(['cart', 'partner_id'])
  },
}
</script>
